import { useSelector } from 'react-redux'
import { Element } from '../../../../../common/html/element'
import { SCREEN } from '../../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../../common/selectCurrencyUnit/useFormatCurrency'
import { valToPercent } from '../../../../../helpers/value'
import { COMPANY_TYPES } from '../../../../../utils/common'
import { selectMethods } from '../../store/slice'

export const FinancialStatementsValueCell = ({
  val,
  locale,
  style,
  isShowCommonYoY,
  tabName,
  companyType,
  colId,
  isCashFlow,
}) => {
  const { value, commonSize, yoyGrowth, exchangeRateType, isDirect } = val || {}
  const { formatCurrency } = useFormatCurrency(SCREEN.FINANCIAL_STATEMENT)

  const methods = useSelector(selectMethods)

  let isDisplay = true

  const isDirectCol = methods.find(
    (item) => String(item.year) === colId,
  )?.isDirect

  if (isCashFlow) {
    isDisplay = isDirect === isDirectCol
  }

  return (
    <>
      {isDisplay && val?.hasData && (
        <div style={{ minWidth: 120, textAlign: 'right', ...style }}>
          <div
            style={{
              fontWeight: val?.fieldStyle?.includes('B') ? 600 : 400,
              width: '100%',
              margin: '4px 0',
              padding: '1px 0',
            }}
          >
            {formatCurrency({
              value,
              year: colId,
              exchangeRateType,
              isFinancialStatement: true,
            })}
            &nbsp;
          </div>
          {isShowCommonYoY && (
            <Element
              style={{
                display: 'flex',
                width: '100%',
                fontSize: 10,
                padding: '2px 0',
                justifyContent: 'space-between',
              }}
            >
              {tabName === 'balanceSheets' ||
              (tabName === 'incomeStatements' &&
                companyType === COMPANY_TYPES.CORPORATE) ? (
                <div>{valToPercent(commonSize, locale, false, true)}</div>
              ) : (
                <div></div>
              )}
              {yoyGrowth === 0 ? (
                <div style={{ paddingLeft: 20 }}>
                  {valToPercent(yoyGrowth, locale)}
                </div>
              ) : (
                <Element
                  style={{
                    paddingLeft: 20,
                    color:
                      yoyGrowth > 0
                        ? '#3DA967'
                        : yoyGrowth < 0
                        ? '#E0505B'
                        : '',
                  }}
                >
                  {yoyGrowth > 0 && '+'}
                  {valToPercent(yoyGrowth, locale)}
                </Element>
              )}
            </Element>
          )}
        </div>
      )}
    </>
  )
}
